import { render, staticRenderFns } from "./SettingsFileConfig.vue?vue&type=template&id=56ce15b4"
import script from "./SettingsFileConfig.vue?vue&type=script&lang=js"
export * from "./SettingsFileConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports